module.exports = __webpack_public_path__ + "media/images/icons/icon-shoe-037c8546b0465240f619ceb7254b2000.svg";